export { default } from './TextLabel';
